import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ConstantData } from 'src/app/services/constants';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent {
  iframeSrc:any;
constructor(private util:UtilService, private sanitizer:DomSanitizer){
  this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.util.isProduction?ConstantData.pp_prod: ConstantData.pp);
}
goTohome(){
  this.util.route('home');
}
}
